import { MouseEvent } from 'react';

import { Box, styled } from '@mui/material';

import { SxProps } from '../../../../types';
import { Input, InputProps } from '../../../controls/input';
import { CalendarBlank, CaretDown, CaretUp } from '../../../icons';

type Props = {
  inputProps: InputProps;
  isOpen: boolean;
  onClick: (event: MouseEvent<HTMLInputElement>) => void;
  sx?: SxProps;
  testId: string;
};

const StyledInput = styled(Input, {
  name: 'DsDatePicker',
  slot: 'Input',
  target: 'DsDatePicker-Input',
  overridesResolver: (_, styles) => {
    return [styles.input];
  },
})({});
StyledInput.displayName = 'StyledInput';

export const DatePickerTrigger = ({
  isOpen,
  onClick,
  inputProps,
  sx,
  testId = 'date-picker',
}: Props) => {
  return (
    <Box onClick={onClick} sx={sx} data-testid={testId}>
      <StyledInput
        placeholder="Select date"
        startAdornment={<CalendarBlank size="20px" />}
        endAdornment={isOpen ? <CaretUp /> : <CaretDown />}
        {...inputProps}
      />
    </Box>
  );
};
